import React from 'react'

import { Body1, Box, Heading2, JustifyContent, Space, Strong } from '@gousto-internal/citrus-react'

export const ContentBlockNDD = (
  <Box
    height="100%"
    width="100%"
    maxWidth={['343px', '552px']}
    justifyContent={JustifyContent.Center}
  >
    <Heading2 size={[9, 10]}>What size boxes does Gousto have?</Heading2>
    <Space size={2} />
    <Body1>
      Did you know that we’re the first recipe box in Britain to serve 1-5 people? Our food boxes
      are made to suit a number of households as we understand that every home looks different.
      Whether you’re a busy family of 5, a couple looking to shake up their dinners, or you live
      alone and want to cut down on food waste, there’s a box for you.
    </Body1>
    <Space size={3} />
    <Body1>
      Don’t forget: you can also change the size of your box and your number of recipes every week,
      should you ever need.
    </Body1>
    <Space size={5} />
    <Heading2 size={[9, 10]}>When will I get my first food box delivery?</Heading2>
    <Space size={2} />
    <Body1>
      It’s easy to sign up to Gousto, in just a few clicks. Choose your box size, decide how many
      delicious dinners you’d like, and pick the ideal day for your meal delivery.
    </Body1>
    <Space size={3} />
    <Body1>
      Our boxes are delivered any day of the week.{' '}
      <Strong>
        You can get your box the next day when you complete the sign-up and checkout process before
        11:59am on Friday, Saturday, Sunday Monday, and Tuesday.
      </Strong>
    </Body1>
    <Space size={3} />
    <Body1>
      It’s really as simple as that. You can skip a box, pause your subscription and cancel at any
      time, at no cost.
      <br />
      Why not join over a million of our customers who are already loving Gousto?
    </Body1>
  </Box>
)
